var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 93,
    viewBox: "0 0 114 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.1501 30L99.8589 82.283C99.9528 83.3255 99.8304 84.3764 99.4995 85.3685C99.1686 86.3607 98.6365 87.2723 97.9371 88.0454C97.2377 88.8185 96.3864 89.4361 95.4373 89.8587C94.4883 90.2813 93.4624 90.4997 92.4251 90.5H91.6294C89.4511 90.5001 87.3226 89.8416 85.5187 88.6093C83.7147 87.377 82.318 85.6275 81.5088 83.5865L76.0915 69.9135C75.2822 67.8725 73.8855 66.123 72.0816 64.8907C70.2776 63.6584 68.1492 62.9999 65.9708 63H58.9294C56.7511 62.9999 54.6226 63.6584 52.8187 64.8907C51.0147 66.123 49.618 67.8725 48.8088 69.9135L43.3915 83.5865C42.5822 85.6275 41.1855 87.377 39.3816 88.6093C37.5776 89.8416 35.4492 90.5001 33.2708 90.5H32.4751C31.4415 90.4999 30.4193 90.2811 29.4746 89.8577C28.5299 89.4344 27.6837 88.8159 26.9904 88.0422C26.2972 87.2685 25.7723 86.3567 25.4497 85.3657C25.1272 84.3746 25.014 83.3264 25.1176 82.2885L29.7501 35.5L13.4001 46.5L2.50012 35.5L18.8501 2.5C35.2001 2.5 51.5501 13.5 51.5501 30H95.1501ZM95.1501 30C99.4864 30 103.645 31.7384 106.711 34.8327C109.778 37.9271 111.5 42.1239 111.5 46.5V57.5",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorse);
export default __webpack_public_path__ + "static/media/horse.273ff20d94803984d2f4c86d7968c7de.svg";
export { ForwardRef as ReactComponent };